import("../../../scss/components/spinner.scss");
const Spinner = () => {
  return (
    <div className="spinner lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
